import { Flex } from 'antd';
import { DocumentPreviewBlock1 } from './DocumentPreviewBlock1';
import { DocumentPreviewBlock2 } from './DocumentPreviewBlock2';
import { DocumentPreviewBlock3 } from './DocumentPreviewBlock3';
import { DocumentPreviewBlock4 } from './DocumentPreviewBlock4';
import { DocumentPreviewBlock5 } from './DocumentPreviewBlock5';
import { DocumentPreviewBlock6 } from './DocumentPreviewBlock6';
import { DocumentPreviewBlock7 } from './DocumentPreviewBlock7';

export type FormBlockTypes = {
  [key: string]: string | boolean | FormBlockTypes;
};

export type FormBlock3DataTypes = {
  methods?: FormBlockTypes;
  requirementsPersonalization?: FormBlockTypes;
  individualSupport?: FormBlockTypes;
};

export type FormBlock4DataTypes = {
  implementationMethods?: FormBlockTypes;
  implementationRequirements?: FormBlockTypes;
};

export type FormBlock6DataTypes = {
  space?: FormBlockTypes;
  tools?: FormBlockTypes;
};

type FormDataTypes = {
  block1?: FormBlockTypes;
  block2?: FormBlockTypes;
  block3?: FormBlock3DataTypes;
  block4?: FormBlock4DataTypes;
  block5?: FormBlockTypes;
  block6?: FormBlock6DataTypes;
  block7?: FormBlockTypes;
};

export type DocumentPreviewBlockProps = {
  data: FormDataTypes;
  selectedSubject: string;
};

export const DocumentPreviewSubjectData = ({
  data,
  selectedSubject,
}: DocumentPreviewBlockProps) => {
  return (
    <Flex
      vertical
      gap={24}
      style={{
        marginTop: 24,
      }}
    >
      <DocumentPreviewBlock1 data={data.block1 || {}} />
      <DocumentPreviewBlock2 data={data.block2 || {}} />
      <DocumentPreviewBlock3
        data={data.block3 || {}}
        selectedSubject={selectedSubject}
      />
      <DocumentPreviewBlock4 data={data.block4 || {}} />
      <DocumentPreviewBlock5
        data={data.block5 || {}}
        selectedSubject={selectedSubject}
      />
      <DocumentPreviewBlock6 data={data.block6 || {}} />
      <DocumentPreviewBlock7 data={data.block7 || {}} />
    </Flex>
  );
};
